import * as THREE from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import * as CANNON from 'cannon-es';

import { Die } from './Die.mjs';

let camera;
let world;
let scene;

export const yatzy = new Yatzy();

// Singleton class for managing components
class Yatzy {

	rollDice() {
		for ( let i = 0; i < this.dice.length; i++ ) {
			this.dice[i].roll(i);
		}
	}

	unlockDice() {
		for ( const die of this.dice ) {
			die.rollLock = false;
		}
	}

	async init() {

		/*
		 *  Init Three
		 */

		this.scene = new THREE.Scene();
		scene = this.scene;
		camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
		camera.position.set(0,0.5,0);

		const renderer = new THREE.WebGLRenderer({ antialias: true });
		renderer.setSize( window.innerWidth, window.innerHeight );
		renderer.shadowMap.enabled = true;
		renderer.shadowMap.type = THREE.PCFSoftShadowMap;
		document.body.appendChild( renderer.domElement );

		const controls = new OrbitControls( camera, renderer.domElement );
		controls.target.set(0,0,0);

		this.topZ = -Math.tan( camera.fov * Math.PI / 180 / 2 ) * Math.abs( -camera.position.y );
		this.leftX = this.topZ * camera.aspect;

		// Table

		const tableGeometry = new THREE.PlaneBufferGeometry(100, 100);
		tableGeometry.rotateX(-Math.PI / 2);
		const tableMaterial = new THREE.MeshLambertMaterial({ color: 0x14361C });
		const table = new THREE.Mesh(tableGeometry, tableMaterial);
		table.receiveShadow = true;
		this.scene.add(table);

		// Lights
		this.addLights();
		
		// Raycaster for clicking dice
		const raycaster = new THREE.Raycaster();
		window.addEventListener('pointerdown', (event) => {
			const mouse = new THREE.Vector2();
			mouse.x =   event.clientX / window.innerWidth  * 2 - 1;
			mouse.y = -(event.clientY / window.innerHeight * 2 - 1);

			raycaster.setFromCamera( mouse, camera );
			for ( const die of this.dice ) {
				const hits = raycaster.intersectObject(die.model);
				if ( hits.length > 0 ) {
					die.toggleRollLock();
				}
			}
		});




		/*
		 * Init Cannon
		 */

		this.world = new CANNON.World()
		world = this.world;
		this.world.gravity.set( 0, -7, 0 ); // lower gravity for better feel

		// Materials
		this.cubeBodyMaterial = new CANNON.Material();
		this.tableBodyMaterial = new CANNON.Material();
		this.world.addContactMaterial( new CANNON.ContactMaterial(this.tableBodyMaterial, this.cubeBodyMaterial, { friction: 0.01, restitution: 0.5 }));
		this.world.addContactMaterial( new CANNON.ContactMaterial(this.cubeBodyMaterial,  this.cubeBodyMaterial, { friction: 0,    restitution: 0.5 }));

		// Table

		const tableShape = new CANNON.Plane();
		const tableBody = new CANNON.Body({
			mass: 0,
			material: this.tableBodyMaterial,
		})
		tableBody.addShape(tableShape);
		tableBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0);
		this.world.addBody(tableBody);

		// Back wall
		this.addWall( 0, 0, 0, 0, 0, this.topZ );
		// Left wall
		this.addWall( 0, Math.PI/2, 0, this.leftX, 0, 0 );
		// Right wall
		this.addWall( 0, -Math.PI/2, 0, -this.leftX, 0, 0 );

		/*
		 * Dice
		 */

		await Die.loadObject();

		this.dice = [];
		for ( let i = 0; i < 5; i++ ) {
			const die = new Die( this.cubeBodyMaterial );
			die.roll(i);
			this.dice.push(die);
			this.scene.add(die.model);
			this.world.addBody(die.body);
		}

		/*
		 * Main animation loop
		 */

		function animate() {
			requestAnimationFrame( animate );

			world.fixedStep();

			for ( const die of yatzy.dice ) {
				die.updateMesh();
			}

			renderer.render( scene, camera );
		};

		animate();
	}

	addWall( eulerX, eulerY, eulerZ, posX, posY, posZ ) {

		const wallGeometry = new THREE.PlaneBufferGeometry(100, 100);
		const wallMaterial = new THREE.MeshLambertMaterial({ color: 0x14361C });
		const wall = new THREE.Mesh(wallGeometry, wallMaterial);
		wall.receiveShadow = true;

		const wallShape = new CANNON.Plane();
		const wallBody = new CANNON.Body({ mass: 0, material: this.tableBodyMaterial });
		wallBody.addShape(wallShape);
		wallBody.quaternion.setFromEuler( eulerX, eulerY, eulerZ);
		wallBody.position.set( posX, posY, posZ );

		wall.position.copy( wallBody.position );
		wall.quaternion.copy( wallBody.quaternion );

		this.world.addBody(wallBody)
		this.scene.add(wall);
	}

	addLights() {
		const ambientLight = new THREE.AmbientLight(0x666666);
		this.scene.add(ambientLight);

		const directionalLight = new THREE.DirectionalLight(0xffffff, 1.2);
		const distance = 2;
		directionalLight.position.set(-distance, distance, distance);

		directionalLight.castShadow = true;

		directionalLight.shadow.mapSize.width = 2048;
		directionalLight.shadow.mapSize.height = 2048;

		directionalLight.shadow.camera.left = -distance;
		directionalLight.shadow.camera.right = distance;
		directionalLight.shadow.camera.top = distance;
		directionalLight.shadow.camera.bottom = -distance;

		directionalLight.shadow.camera.far = 3 * distance;
		directionalLight.shadow.camera.near = distance;

		this.scene.add(directionalLight);
	}

}
